import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {CommonItemDetailsComponent} from '@emm/common-items/components/common-item-details/common-item-details.component';
import {Router} from '@angular/router';

@Component({
    selector: 'emm-common-item',
    templateUrl: './common-item.component.html',
    styleUrl: './common-item.component.scss'
})
export class CommonItemComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() selectedItem: any;
    @Input() selectedFeatureScope: string;
    @Input() selectedLocation: string;
    @Input() selectedConsumer: string;
    @Input() selectedSubmenu;
    isReadOnly = true;
    isLoading = false;
    context$ = new BehaviorSubject<{
        featureScope: string;
        location: string;
        submenu: string;
        consumer?: string;
    } | null>(null);
    private destroy$ = new Subject<void>();

    @ViewChild(CommonItemDetailsComponent) itemDetailComponent: CommonItemDetailsComponent;

    constructor(
        private router: Router,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.context$.next({
            featureScope: this.selectedFeatureScope,
            location: this.selectedLocation,
            consumer: this.selectedConsumer,
            submenu: this.selectedSubmenu,
        });
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    editCommonItem() {
        console.log(this.selectedItem);
        let url: string;
        if (this.selectedItem.class === 'ITEM' || this.selectedItem.objectType === 'ITEM') {
            url = this.router.serializeUrl(
                this.router.createUrlTree(['/common-items/item-detail', this.selectedItem.tag])
            );
            window.open(url, '_blank');
        } else if (this.selectedItem.class === 'ITEM_GROUPING' || this.selectedItem.objectType === 'ITEM_GROUPING') {
            url = this.router.serializeUrl(
                this.router.createUrlTree(['/common-items/item-group-detail', this.selectedItem.tag])
            );
            window.open(url, '_blank');
        }else if (this.selectedItem.class === 'MODIFIER_GROUPING' || this.selectedItem.objectType === 'MODIFIER_GROUPING') {
            url = this.router.serializeUrl(
                this.router.createUrlTree(['/common-items/modifier-group-detail', this.selectedItem.tag])
            );
            window.open(url, '_blank');
        } else if (this.selectedItem.class === 'MODIFIER' || this.selectedItem.objectType === 'MODIFIER') {
            url = this.router.serializeUrl(
                this.router.createUrlTree(['/common-items/modifier-detail', this.selectedItem.tag])
            );
            window.open(url, '_blank');
        }
    }
}
